<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Anexos</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <template v-if="anexos.length > 0">
      <v-list two-line>
        <template v-for="(item, index) in anexos">
          <v-list-tile :key="item.id">
            <v-list-tile-content class="pl-5">
              <v-list-tile-sub-title>{{ item.data }} às {{ item.horario }}</v-list-tile-sub-title>
              <v-list-tile-title>{{ item.titulo }}</v-list-tile-title>
              <v-list-tile-sub-title class="grey--text text--darken-4">{{ item.legenda }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="pr-5">
              <v-menu>
                <v-icon slot="activator">more_vert</v-icon>
                <v-list>
                  <v-list-tile :href="item.path" target="_blank" download>
                    <v-list-tile-title>Visualizar</v-list-tile-title>
                  </v-list-tile>
                  <v-dialog v-model="dialogEditar" persistent lazy max-width="640" v-if="$hasGranularPermission('anexos', 'edit')">
                    <v-list-tile slot="activator" @click.native="beforeEditar(item)">
                      <v-list-tile-title>Editar</v-list-tile-title>
                    </v-list-tile>
                    <v-card>
                      <v-card-title>
                        <div class="title">{{ itemEditar.titulo }}</div>
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model="formEditar.fields.legenda"
                          label="Legenda"
                        >
                        </v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
                        <v-btn class="secondary--text" flat @click.native="onSubmitEditar()">Salvar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <br>
                  <v-dialog v-model="dialogApagar" lazy max-width="520" v-if="$hasGranularPermission('anexos', 'delete')">
                    <v-list-tile slot="activator" @click.native="beforeApagar(item)">
                      <v-list-tile-title>Apagar</v-list-tile-title>
                    </v-list-tile>
                    <v-card>
                      <v-card-title>
                        <div class="headline">Tem certeza que deseja apagar?</div>
                      </v-card-title>
                      <v-card-text>Essa ação não poderá ser desfeita.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="secondary--text" flat @click.native="dialogApagar = false">Descartar</v-btn>
                        <v-btn class="error--text" flat @click.native="onSubmitApagar()">Apagar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < anexos.length" :key="item.id"></v-divider>
        </template>
      </v-list>
      <IrParaOTopo></IrParaOTopo>
    </template>
    <p class="text-xs-center mt-5 subheading" v-else>Nenhum anexo cadastrado.</p>
    <v-dialog v-model="dialog" persistent lazy max-width="720">
      <v-btn dark fab fixed bottom right class="secondary" slot="activator" v-if="$hasGranularPermission('anexos', 'add')">
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-card-text>
          <file-input
            v-model="form.fields.anexoFilename"
            @formData="onFilePicked"
            label="Selecionar arquivo"
            :key="inputKey">
          </file-input>
          <v-text-field
            v-model="form.fields.legenda"
            label="Legenda"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
          <v-btn class="secondary--text" flat @click.native="onSubmit">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import IrParaOTopo from '../../Utils/IrParaOTopo'
  import FileInput from '../../Utils/FileInput'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'

  export default {
    components: {
      IrParaOTopo,
      FileInput,
      HeadersDetalhesResumo
    },
    data () {
      return {
        componentVoltar: (this.$route.params.tipo === 'geral') ? 'ImoveisDetalhesResumo' : `ImoveisDetalhes${_.upperFirst(this.$route.params.tipo)}`,
        dialog: false,
        dialogEditar: false,
        dialogApagar: false,
        imovelId: this.$route.params.id,
        inputKey: Math.random(),
        form: {
          fields: {
            tipo: this.$route.params.tipo,
            legenda: '',
            anexo: null,
            anexoFilename: ''
          }
        },
        formEditar: {
          fields: {
            legenda: ''
          }
        },
        itemEditar: {},
        itemApagar: {}
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      anexos () {
        return this.$store.getters['imoveis/anexos'](this.$route.params.tipo)
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    methods: {
      onFilePicked (event) {
        this.form.fields.anexo = event
      },
      descartar () {
        this.dialog = false
        this.dialogEditar = false
        this.dialogApagar = false
        this.form.fields.legenda = ''
        this.form.fields.anexo = null
        this.form.fields.anexoFilename = ''
        this.formEditar.fields.legenda = ''
        this.inputKey = Math.random()
        this.errors.clear()
      },
      beforeEditar (item) {
        document.querySelectorAll('.menu__content').forEach((a) => { a.style.display = 'none' })
        this.formEditar.fields.legenda = item.legenda
        this.itemEditar = item
      },
      beforeApagar (item) {
        document.querySelectorAll('.menu__content').forEach((a) => { a.style.display = 'none' })
        this.itemApagar = item
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('adicionar').then((result) => {
          if (result) {
            const formData = new FormData()

            Object.keys(this.form.fields).forEach((key) => {
              formData.append(key, this.form.fields[key])
            })

            axios.post(`${apiURL}/anexos/${this.imovelId}`, formData).then(() => {
              this.$store.dispatch('imoveis/loadImovel', { id: this.imovelId }).finally(() => {
                this.descartar()
                this.$store.dispatch('utils/hideLoading')
              })
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitEditar () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('editar').then((result) => {
          if (result) {
            axios.patch(`${apiURL}/anexos/${this.itemEditar.id}`, this.formEditar.fields).then((response) => {
              this.$store.dispatch('imoveis/updateAnexo', { item: this.itemEditar, legenda: this.formEditar.fields.legenda })
              this.descartar()
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitApagar () {
        axios.delete(`${apiURL}/anexos/${this.itemApagar.id}`).then((response) => {
          this.$store.dispatch('imoveis/deleteAnexo', this.itemApagar)
          this.descartar()
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      }
    }
  }
</script>

<style scoped>
@media (max-width: 599px) {
  .pl-5,
  .pr-5 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// DetalhesAnexos.vue?0db7d3f6